<template>
  <div :ref="controlRef">
    <DxSelectBox
      ref="selectBox"
      v-model="valueData"
      class="ms-select-box"
      :style="[{ width: isNaN(width) ? width : width + 'px' }, { height: '500px' }]"
      :class="{ isValid: errorProvider.isValid,'italic-place':isPlaceholderItalic,'gray-place':isPlaceholderGray }"
      :disabled="disabled"
      :data-source="dataSourceX"
      :display-expr="displayExpr"
      :value-expr="valueExpr"
      :search-expr="searchExpr"
      :search-enabled="searchEn"
      :show-clear-button="showClearButton"
      item-template="item"
      no-data-text="Không có dữ liệu"
      :placeholder="placeholder"
      :drop-down-options="dropDownOptions"
      @on-focus-in="onOpened"
      @valueChanged="valueChange"
      @itemClick="itemClick"
    >
      <template #item="{ data }">
        <div class="flex items-center item-select-box">
          <slot
            name="item-template"
            :data="data"
          >
            <span
              class="wrap-text"
              :title="data[displayExpr]"
            >{{ data[displayExpr] }}</span>
          </slot>
        </div>
      </template>
    </DxSelectBox>
    <p
      v-if="errorProvider.isValid"
      class="text-error"
    >
      {{ errorProvider.message }}
    </p>
  </div>
</template>
<script>
import DxSelectBox from "devextreme-vue/select-box";
import DataSource from "devextreme/data/data_source";
import CustomStore from "devextreme/data/custom_store";
import msBaseComponent from "@/components/controls/msbase/msBaseComponent.vue";
import { MsControlRef } from "@/models/enums/MsControlRefConst.js";

export default {
  name: "MsSelectBox",
  components: {
    DxSelectBox,
  },
  extends: msBaseComponent,
  props: {
    // Vị trí của các select nếu nằm trong 1 vòng for
    index: {
      type: Number,
      default: null,
    },
    // Kiểm tra có xóa khi double click phần tử
    isDeleteItem: {
      type: Boolean,
      default: true,
    },
    //Giá trị truyền xuống
    value: {
      type: [String, Number],
      default: null,
    },
    //Danh sách dữ liệu đổ vào
    dataSource: {
      type: Array,
      default:() => [],
    },
    //Có disabled hay không
    disabled: {
      type: Boolean,
      default: false,
    },
    //Tên khởi tạo ban đầu nếu có
    initItem: {
      type: String,
      default: null,
    },
    //Chiều dài của control
    width: {
      type: [String, Number],
      default: "100%",
    },
    //Trường xét giá trị
    valueExpr: {
      type: String,
      default: null,
    },
    //Trường hiển thị text
    displayExpr: {
      type: String,
      default: null,
    },
    //Các trường cần tìm kiếm
    searchExpr: {
      type: [Array, String],
      default: () => [],
    },
    //placeholder
    placeholder: {
      type: String,
      default: "",
    },

    /**
     * placeholder có nghiêng không
     * Created by THNhat(23.02.2022)
     */
    isPlaceholderItalic: {
      type: Boolean,
      default: false,
    },

    /**
     * placeholder có màu xám không không
     * Created by THNhat(23.02.2022)
     */
    isPlaceholderGray: {
      type: Boolean,
      default: false,
    },

    //Thêm điều kiện lọc
    filter: {
      type: String,
      default: null,
    },
    // thêm điều kiện sắp xếp
    sort: {
      type: String,
      default: null,
    },
    //Có gọi paging hay đổ dữ liệu bình thường, nếu dùng dữ liệu local thì prop này = false
    isPaging: {
      type: [String, Boolean],
      default: true,
    },
    isLoadingAfterMounted: {
      type: [String, Boolean],
      default: false,
    },
    // có sử dụng quicksearch không
    useQuickSearch: {
      type: Boolean,
      default: true,
    },
    //Hàm paging
    functionPaging: {
      type: Function,
      default: () => {},
    },
    //Hàm xử lý thêm sau khi gọi paging
    afterGetPaging: {
      type: Function,
      default: null,
    },
    // custome filter search selectbox
    getFilterCustome: {
      type: Function,
      default: null,
    },
    // trường nhận cho search hay không
    searchEn: {
      type: Boolean,
      default: true,
    },
    showClearButton: {
      type: Boolean,
      default: false,
    },
    isPagingSource: {
        type: Boolean,
        default: true,
    }
  },
  data() {
    return {
      isLoadData: true,
      previousValue: null,
      dropDownOptions: undefined,
      controlRef: MsControlRef.MsSelectBox,
      valueData: this.value,
      dataSourceX: [],
      listDataEmit: [],
      lastPageIndex: 0
    };
  },
  watch: {

    value(val){
      this.valueData = val
    },
    
    valueData(val) {
      this.internalText = val;
      this.validate(val);
    },

    dataSource: {
      immediate: true,
      handler(newVal, oldVal) {
        if (!this.isPaging) {
          this.dataSourceX = newVal;
        }
      },
    }
  },
  created() {
    if (this.isLoadData && this.isPaging) {
      if (this.isLoadingAfterMounted) {
        setTimeout(() => {
          this.loadDataPaging();
          this.isLoadData = false;
          if (
            this.dataSourceX._items.length == 0 &&
            this.valueData &&
            this.initItem
          ) {
            var newItem = {};
            newItem[this.valueExpr] = this.valueData;
            newItem[this.displayExpr] = this.initItem;
            this.dataSourceX._items.push(newItem);
          }
        }, 400);
      } else {
        this.loadDataPaging();
        this.isLoadData = false;
        if (
          this.dataSourceX._items.length == 0 &&
          this.valueData &&
          this.initItem
        ) {
          var newItem = {};
          newItem[this.valueExpr] = this.valueData;
          newItem[this.displayExpr] = this.initItem;
          this.dataSourceX._items.push(newItem);
        }
      }
    }
  },
  mounted() {
    let me = this;
    this.dropDownOptions = {
      onShown: function (args) {
        if (me.dataSourceX && me.dataSourceX.length < 5) {
          args.component.content().classList.add("ms-select-box");
        }
      },
    };
  },
  methods: {
    /**
     * @override
     */
    focusError(){
      this.$refs.selectBox.instance.open();
    },
    onShow(args) {},

    /**
     * Hàm xảy ra khi mở combo
     * Created by cvcuong1 - 7/5/2021
     */
    onOpened(e) {
      // if (this.isLoadData && this.isPaging) {
      //   this.loadDataPaging();
      //   this.isLoadData = false;
      // }
    },
    /**
     * Hàm tạo dữ liệu dạng get paging
     * created by cvcuong1 - 7/5/2021
     */
    loadDataPaging() {
      const me = this;
      me.dataSourceX = new DataSource({
        store: new CustomStore({
          load: (loadOptions) => {
            const params = { 
              PageSize: loadOptions.take || 10,
              PageIndex:
                Math.ceil(loadOptions.skip / loadOptions.take) + 1 || 1,
            };

            if (!me.isPagingSource && params.PageIndex > 1) {
              return;
            }

            let where = [];
            if (loadOptions.searchValue) {
              let value = encodeURI(loadOptions.searchValue);
              where.push([me.searchExpr, "contains", value]);
            }

            if (where.length) {
              params.Filter = btoa(JSON.stringify(where));
            }

            if (me.sort) {
              params["Sort"] = me.sort;
            }
            return new Promise((resolve, reject) => {
              me.functionPaging(params)
                .then(function (result) {
                  if (result.data && result.data.Success) {
                    // Fix cho những trường hợp dữ liệu trả về không có PageData
                    if (!result.data.Data.PageData && result.data.Data && result.data.Data.length) {
                      result.data.Data.PageData = result.data.Data;
                    }

                    if (
                      result.data.Data.PageData &&
                      result.data.Data.PageData.findIndex(
                        (x) => x[me.valueExpr] == me.valueData
                      ) != -1
                    ) {
                      var valueCurrent = me.valueData;
                      // me.value = null;
                      // setTimeout(() => {
                      //   me.value = valueCurrent;
                      // }, 0);
                    }
                    if (me.afterGetPaging) {
                      me.afterGetPaging(result.data.Data.PageData);
                    }

                    // Lưu listDataEmit để sau này emit
                    if (me.lastPageIndex < params.PageIndex) {
                      me.listDataEmit.push(...result.data.Data.PageData);
                    }
                    else if (me.lastPageIndex > params.PageIndex) {
                      me.listDataEmit = result.data.Data.PageData;
                    }
                    me.lastPageIndex = params.PageIndex;

                    resolve(result.data.Data.PageData);
                  }
                })
                .catch((err) => reject(err));
            });
          },
          byKey: function (key) {
            return { id: key[me.valueExpr] };
          },
          loadMode: "processed",
        }),
        pageSize: 20,
      });
    },
    /**
     * Hàm chọn nhân viên
     * Created by cvcuong1 - 7/5/2021
     */
    itemClick(e) {
      if (this.isDeleteItem == true) {
        // nếu click vào chính item đó thì remove đi
        if (this.previousValue == e.itemData[this.valueExpr]) {
          // this.value = null;
          this.previousValue = null;
          this.$emit("input", null);
          this.$emit("selected", null);
        } else {
          this.previousValue = e.itemData[this.valueExpr];
          this.$emit("input", e.itemData[this.valueExpr]);
          this.$emit("selected", e.itemData);
        }
      }
    },

    /**
     * sự kiện thay đổi giá trị selectbox
     * nhviet 2021.09.01
     */
    valueChange(e) {
      let valueEmit = null;
      if (e.value) {
        valueEmit =
          this.dataSourceX && !this.isPaging
            ? this.dataSourceX.find((x) => x[this.valueExpr] == e.value)
            : null;

        if (!valueEmit && this.dataSourceX && this.dataSourceX._items) {
          valueEmit = this.listDataEmit.find(
            (x) => x[this.valueExpr] == e.value
          );
        }
      }
      this.$emit("valueChange", valueEmit, this.index);
    },
    // override lại hàm validate base
    // nhviet
    validateRequired(value) {
      if (this.valueData) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/controls/_variables.scss";
.dx-selectbox-popup-wrapper {
  .dx-overlay-content {
    border: none !important;
    padding: 0px;
    // min-height: 80px;
    min-height: 42px;
  }
  .dx-scrollbar-vertical.dx-scrollbar-hoverable {
    margin-right: -10px;
  }
  .dx-list-item.dx-state-focused {
    background-color: var(--primary-bg) !important;
    color: var(--text-primary-color) !important;
  }
  .dx-list-item.dx-list-item-selected {
    background-color: var(--primary-bg) !important;
    color: var(--primary) !important;
  }
  .dx-list-item.dx-state-active {
    background-color: var(--primary-bg) !important;
    color: var(--primary) !important;
  }
  .dx-list-item {
    border-radius: 4px;
  }
  .dx-popup-content {
    padding: 0 8px;
  }
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .item-select-box {
    display: flex !important;
    padding: 8px !important;
  }
  .dx-empty-message {
    font-style: italic;
    font-weight: 500;
    color: var(--text-secondary-color);
  }
}
.ms-select-box.isValid {
  border: 1px solid $input-error-border-color !important;
}
.ms-select-box.dx-state-focused {
  border: 1px solid var(--primary) !important;
}
.ms-select-box.dx-state-hover {
  border: 1px solid var(--primary) !important;
}

.ms-select-box {
  border-radius: 4px;
  .dx-dropdowneditor-icon {
    background-color: #ffffff !important;
    border: none !important;
  }
  .dx-icon-clear {
    color: #999;
    position: absolute;
    top: 50%;
    margin-top: -17px;
    padding: 8px;
    width: 34px;
    height: 34px;
    background-position: 8px 8px;
    background-size: 18px 18px;
    font-size: 18px;
    text-align: center;
    line-height: 18px;
    transform: scale(0.8);
  }
}
.ms-select-box {
  height: auto !important;
}
.dx-state-disabled .dx-widget,
.dx-state-disabled.dx-widget {
  opacity: unset;
}
.dx-state-disabled .dx-selectbox .dx-texteditor-input,
.dx-state-disabled.dx-selectbox .dx-texteditor-input {
  color: black !important;
}

.italic-place .dx-placeholder::before {
  font-style: italic !important;
}

.gray-place .dx-placeholder::before {
  color: #9ea5a6 !important;
}
</style>
